import QueryLink from './QueryLink';

const DepositLink = QueryLink({ modal: 'deposit' });

export default DepositLink;
